import React from 'react'
import { useSelector } from 'react-redux'
import { accessActions } from '../../redux/slice/access.slice'
import { checkSinglePermission } from './helper'
import { authActions } from '../../redux/slice/auth.slice'

const CheckSinglePerm = ({ allowedPerm, children }) => {
    const userPermissions = useSelector(accessActions.selectors.getUserPermissions)
    const currentUser = useSelector(authActions.selectors.getCurrentUser);
    return (
        <>
            {checkSinglePermission(allowedPerm, userPermissions, currentUser?.role) &&
                children
            }
        </>
    )
}

export default CheckSinglePerm
